'use strict';

module.exports = {
    groupOfProducts: 'groupOfProducts',
    individualProducts: 'individualProducts',
};
